import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISerpQuerySettings } from "../../models/SerpQuery/SerpQuery";
import { SerpQueryKeys } from "./keys";

export default function useSerpQuerySettings(enabled: boolean) {
  const { get } = useApiHelper();

  return useQuery({
    queryKey: SerpQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<ISerpQuerySettings>>("/serp-query-settings").then(
        (res) => res.data,
      ),
    enabled,
  });
}
